import { useAuth } from "../../authContext";
import WizrButton from "../WizrButton"
import { useNavigate } from "react-router-dom"

const AppRun=(appDetail:any):JSX.Element=>{
    const navigate = useNavigate()
    const {hasAcces } = useAuth();

    
    const onRunClick=()=>{
        navigate("/bulkrun",{state:{appDetail,source:'list'}})
    }
    return(
        <WizrButton type='primary' text='RUN' style={{borderRadius:"20px"}} disabled={!hasAcces('view_bulkrun')} onClick={onRunClick}/>
    )
}
export default AppRun